/**
 * A TypeScript source listing with Prism tokens coloured by semantic tokens,
 * so the file reads as code without hardcoded palette colours.
 */

import Prism from 'prismjs'
import 'prismjs/components/prism-typescript'

const TOKEN_CLASS: Record<string, string> = {
  comment: 'text-muted-foreground italic',
  keyword: 'text-primary font-medium',
  string: 'text-success',
  'template-string': 'text-success',
  number: 'text-warning',
  boolean: 'text-warning',
  function: 'text-foreground font-medium',
  'class-name': 'text-foreground font-medium',
  punctuation: 'text-muted-foreground',
  operator: 'text-muted-foreground',
}

type Stream = string | Prism.Token | Array<string | Prism.Token>

function render(stream: Stream, key: number): React.ReactNode {
  if (typeof stream === 'string') return stream
  if (Array.isArray(stream)) return stream.map((item, index) => render(item, index))
  const className = TOKEN_CLASS[stream.type] ?? 'text-foreground'
  return (
    <span key={key} className={className}>
      {render(stream.content, 0)}
    </span>
  )
}

export function CodeBlock({ text }: { text: string }): React.JSX.Element {
  const grammar = Prism.languages.typescript
  if (grammar === undefined) throw new Error('Prism has no TypeScript grammar loaded')
  const tokens = Prism.tokenize(text, grammar)
  return (
    <pre className="max-h-96 overflow-auto rounded-sm border border-border bg-background p-3 font-mono text-xs leading-relaxed">
      <code>{tokens.map((token, index) => render(token, index))}</code>
    </pre>
  )
}
